import { useEffect } from 'react';

import { useAppSelector } from '../state';
import { useAppDispatch } from '../state/hooks';
import { queryStyleDetail } from '../state/image';

export function useStyle({ avatar_style_id }: { avatar_style_id?: number }) {
  const { name: styleName, picUrl } =
    useAppSelector((state) => state.image.styleNameMap[avatar_style_id || 0]) || {};
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!styleName && avatar_style_id) {
      dispatch(queryStyleDetail(avatar_style_id));
    }
  }, [avatar_style_id, dispatch, styleName]);

  return { styleName, picUrl };
}
